function search(node) {

    let url = $('base').attr('href') + 'index.php?route=product/search';

    let filter_name = node.closest(".search-div").querySelector('input[name=\'filter_name\']').value;

    if (filter_name) {
        url += '&filter_name=' + encodeURIComponent(filter_name);
    }

    location = url;
}


$(document).ready(function() {
    // $('.button-search').on('click', function() {
    //
	// 	// $('input[name=\'filter_name\']').attr('value',$(this).attr('value'));
    //     // let filter_name = $(this).parent().find('input[name=\'filter_name\']').attr('value');
    //     let filter_name = $(this).parent().children();
    //     console.log(filter_name);
    //     if (filter_name) {
    //         url += '&filter_name=' + encodeURIComponent(filter_name);
    //     }
	// 	console.log(url);
    //     //
    //
    // });

    $('#search input[name=\'filter_name\']').on('keydown', function(e) {
        if (e.keyCode == 13) {
            url = $('base').attr('href') + 'index.php?route=product/search';
			$('input[name=\'filter_name\']').attr('value',$(this).val());
            var filter_name = $('input[name=\'filter_name\']').val();
            if (filter_name) {
                url += '&filter_name=' + encodeURIComponent(filter_name);
            }
            location = url;
        }
		$('input[name=\'filter_name\']').attr('value',$(this).attr('value'));
    });

    $('#cart > .heading').on('click', function() {
        location = "index.php?route=checkout/cart";
    });

    $('#menu ul > li > a + div').each(function(index, element) {
        // if ($.browser.msie && ($.browser.version == 7 || $.browser.version == 6)) {
        if (navigator.appVersion.indexOf("MSIE") !== -1 && ($.browser.version == 7 || $.browser.version == 6)) {
            var category = $(element).find('a');
            var columns = $(element).find('ul').length;
            $(element).css('width', (columns * 143) + 'px');
            $(element).find('ul').css('float', 'left');
        }
        var menu = $('#menu').offset();
        var dropdown = $(this).parent().offset();
        i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());
        if (i > 0) {
            $(this).css('margin-left', '-' + (i + 5) + 'px');
        }
    });
    // if ($.browser.msie) {
    if (navigator.appVersion.indexOf("MSIE") !== -1) {
        if ($.browser.version <= 6) {
            $('#column-left + #column-right + #content, #column-left + #content').css('margin-left', '195px');
            $('#column-right + #content').css('margin-right', '195px');
            $('.box-category ul li a.active + ul').css('display', 'block');
        }
        if ($.browser.version <= 7) {
            $('#menu > ul > li').on('mouseover', function() {
                $(this).addClass('active');
            });
            $('#menu > ul > li').on('mouseout', function() {
                $(this).removeClass('active');
            });
        }
    }
    $('.success img, .warning img, .attention img, .information img').on('click', function() {
        $(this).parent().fadeOut('slow', function() {
            $(this).remove();
        });
    });
    $('body').on('hover', '.sub-menu',function() {
        $(this).closest("li").addClass('sfHover')
    });
    $('body').on('mouseleave','.sub-menu',function() {
        $(this).closest("li").removeClass('sfHover')
    });
    $(function() {
    	//move_up
        $(window).on('scroll', function() {
            if ($(this).scrollTop() > 200) $('a#move_up').fadeIn();
            else $('a#move_up').fadeOut(400);
        });
        $('a#move_up').on('click',function() {
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });

        //filter btn mobile
		$(window).on('scroll', function() {
			if ($(this).scrollTop() > 400)
				$('.filter-adaptive').addClass('cut');
			else
				$('.filter-adaptive').removeClass('cut');
		});
    });
});

function getURLVar(urlVarName) {
    var urlHalves = String(document.location).toLowerCase().split('?');
    var urlVarValue = '';
    if (urlHalves[1]) {
        var urlVars = urlHalves[1].split('&');
        for (var i = 0; i <= (urlVars.length); i++) {
            if (urlVars[i]) {
                var urlVarPair = urlVars[i].split('=');
                if (urlVarPair[0] && urlVarPair[0] == urlVarName.toLowerCase()) {
                    urlVarValue = urlVarPair[1];
                }
            }
        }
    }
    return urlVarValue;
}

function messageAlert(type, message) {
    var $notification = $('#notification'),
        timer;
    if (!$notification.length) {
        $notification = $('#notification');
    }
    clearTimeout(timer);
    $notification.html('<div class="' + type + '">' + message + '<img src="catalog/view/theme/default/image/close.png" onclick="document.getElementById(\'#notification\').classList.remove(\'active\')" class="close" /></div>');
    $notification.addClass('active').children().css('display', 'none').fadeIn('slow', function() {
        timer = setTimeout(function() {
            $notification.removeClass('active');
        }, 8000);
    });
}

function addToCart(product_id, quantity, reload) {
    quantity = typeof(quantity) != 'undefined' ? quantity : 1;
    reload = typeof(reload) != 'undefined' ? reload : false;
    $.ajax({
        url: 'index.php?route=checkout/cart/add',
        type: 'post',
        data: 'product_id=' + product_id + '&quantity=' + quantity,
        dataType: 'json',
        success: function(json) {
            $('.success, .warning, .attention, .information, .error').remove();
            if (json['redirect']) {
                location = json['redirect'];
            }
            if (json['success']) {
                messageAlert('success', json['success']);
                $('#cart-items').html(json['total']);
                if (reload) {
                    location.reload();
                }
				yaCounter25744850.reachGoal('addToCart');
            }
        }
    });
}

function addToWishList(product_id) {
    $.ajax({
        url: 'index.php?route=account/wishlist/add',
        type: 'post',
        data: 'product_id=' + product_id,
        dataType: 'json',
        success: function(json) {
            $('.success, .warning, .attention, .information').remove();
            if (json['success']) {
                messageAlert('success', json['success']);
                $('#wishlist-total').html(json['total']);
            }
        }
    });
}

function addToCompare(product_id) {
    $.ajax({
        url: 'index.php?route=product/compare/add',
        type: 'post',
        data: 'product_id=' + product_id,
        dataType: 'json',
        success: function(json) {
            $('.success, .warning, .attention, .information').remove();
            if (json['success']) {
                $('#notification').html('<div class="success" style="display: none;">' + json['success'] + '<img src="catalog/view/theme/default/image/close.png" alt="" class="close" /></div>');
                messageAlert('success', json['success']);
                $('#compare-total').html(json['total']);
            }
        }
    });
}

function cRub() {
    var ms_ie = false;
    var ua = window.navigator.userAgent;
    var old_ie = ua.indexOf('MSIE ');
    var new_ie = ua.indexOf('Trident/');
    if ((old_ie > -1) || (new_ie > -1)) {
        ms_ie = true;
    }
    if (ms_ie) {
        $(".price-r").html('Р.');
    }
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        $(".price-r").html('Р.');
    }
}

// jQuery(function(){ // TODO: переделать под swiper
// 	jQuery('#camera_wrap_0').camera({
// navigation: true,
// playPause: false,
// thumbnails: false,
// navigationHover: false,
// barPosition: 'top',
// loader: false,
// time: 5000,
// transPeriod:1800,
// alignment: 'center',
// autoAdvance: true,
// mobileAutoAdvance: true,
// barDirection: 'leftToRight',
// barPosition: 'bottom',
// easing: 'easeInOutExpo',
// fx: 'simpleFade',
// height: '42%',
// width: '100%',
// minHeight: '200px',
// hover: true,
// onEndTransition: function () {
//
// },
//
// pagination: true,
// 		loaderColor			: '#1f1f1f',
// 		loaderBgColor		: 'transparent',
// 		loaderOpacity		: 1,
// 		loaderPadding		: 0,
// 		loaderStroke		: 3,
// 	});
// });

$(document).ready(function () {
	$('.colorbox').magnificPopup({
		type: 'image',
		mainClass: 'mfp-with-zoom', // this class is for CSS animation below
		zoom: {
			enabled: true, // By default it's false, so don't forget to enable it
			duration: 300, // duration of the effect, in milliseconds
			easing: 'ease-in-out', // CSS transition easing function
			opener: function (openerElement) {
				return openerElement.is('img') ? openerElement : openerElement.find('img');
			}
		}
	});
//
//	$('.image-additional)
	$('.product-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			titleSrc: function(item) {
				return item.el.attr('title') + '';
			}
		}
	});
});

function discription_more() {
	if ($('.main_description div').hasClass('opened')) {
		$('.main_description div').removeClass('opened');
		$('#discription-more').removeClass('active');
		$('#discription-more').html('<span>подробнее</span>');

	} else {
		$('.main_description div').addClass('opened');
		$('#discription-more').addClass('active');
		$('#discription-more').html('<span>скрыть</span>');
	}
	return false;
}
/* manufacturer list */
function manufacturerPopUp(){

    $.ajax({
        url: '/index.php?route=product/manufacturer/getList', type: 'post', dataType: 'json',
        success: function (json) {
            $('.success, .warning, .attention, .information, .error').remove();

            html='';

            // html = '<a id="close-popup" href=""><i class="fa fa-times"></i></a><div class="popup-manufacturer">';
            // html += '<div class="popup-manufacturer-title">ВЫБЕРИТЕ ПРОИЗВОДИТЕЛЯ</div>';
            // html += '<ul>';
            var col = (json['manufacturers'].length) / 3;
            var count = 0;
            for (var i in json['manufacturers']) {
                count++;
                html += '<div><a href="' + json['manufacturers'][i]['href'] + '"><img src="' + json['manufacturers'][i]['flag'] + '" />' + json['manufacturers'][i]['name'] + '</a></div>'
                // if (count >= col) {
                //     count = 0;
                //     html += '</ul><ul>';
                // }
            }
            // html += '</ul>';
            // html += '</div>';

            $('#manufacturerModal .modal-body').html(html);
            $('#manufacturerModal').modal('show');
            // $('#popup').css('display', 'block');
            // $('#popup-overlay').css('display', 'block');
        }
    });
    return false;
}
$('a[href="#manufacturer-list"]').on('click', function () {
    manufacturerPopUp();
});	
$('#popup-overlay').on('click', function() { $('#popup').css('display', 'none'); $('#popup-overlay').css('display', 'none'); return false;});
$('#close-popup').on('click', function() { $('#popup').css('display', 'none'); $('#popup-overlay').css('display', 'none'); return false; });
/*//footer
$(document).ready(function(){
cRub(); /* вывод знак рубля 
});
function checkNumberFields(e, k){
	var str = jQuery(e).val();
	var new_str = s = "";
	for(var i=0; i < str.length; i++){
		s = str.substr(i,1);
		if(s!=" " && isNaN(s) == false){ // если цифра
			new_str += s;
		}
	}
	if(eval(new_str) > 200){ new_str = 200; }
	if(eval(new_str) == 0){ new_str = ""; }
	jQuery(e).val(new_str);
}

jQuery("[name^='quantity']").keyup(function(event){ // когда пользователь отпускает клавишу клавиатуры
    checkNumberFields(this, event);
}).keypress(function(event){ // когда пользователь нажимает клавишу клавиатуры и удерживает её в нажатом состоянии
    checkNumberFields(this, event);
}).change(function(event){ // когда поля теряет фокус
    checkNumberFields(this, event);
}).click(function(){
	this.select();
});
//<!-- Start SiteHeart code -->

(function(){
var widget_id = 792654;
_shcp =[{widget_id : widget_id}];
var lang =(navigator.language || navigator.systemLanguage 
|| navigator.userLanguage ||"en")
.substr(0,2).toLowerCase();
var url ="widget.siteheart.com/widget/sh/"+ widget_id +"/"+ lang +"/widget.js";
var hcc = document.createElement("script");
hcc.type ="text/javascript";
hcc.async =true;
hcc.src =("https:"== document.location.protocol ?"https":"http")
+"://"+ url;
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hcc, s.nextSibling);
})();

//<!-- End SiteHeart code -->


jQuery(document).ready(function($) {
    setTimeout(function() {
       $('#sh_button').css('display', 'block !important');
		//alert();
    }, 2000);
});

*/
$('.left-menu .category > ul > li > a').on( "dblclick", function () {
	location = $(this).attr("href");
	return false;
});

$('.left-menu .category > ul > li > ul > li > a').on( "click", function() {
	location = $(this).attr("href");
	return false;
});

$('.left-menu .category > ul > li').on( "click", function() {

	if($(this).hasClass('active')){
		$(this).removeClass('active');
	}else{
		$('.left-menu .category li').removeClass('active');
		$(this).addClass('active');
	}
	//return false;
});



////////////////////////////////////// adaptiv filter catalog
function show_filter_rigth(data){
	var display = $(data).css('display');
	if(display == "block"){
		$(data).css({'display':'none','width':'0px'});
	}else{
		$(data).css("display","block");
		$(data).animate({width:"100%"},500)
	}
	var filter = $(data).parent('div').find('.close_filtr').css('display');
	if(filter == "inline-block"){
		$(data).parent('div').find('.close_filtr').css('display','none')
		$(data).parent('div').find('.open_filtr').css('display',' inline-block')
	}else{
		$(data).parent('div').find('.close_filtr').css('display',' inline-block')
		$(data).parent('div').find('.open_filtr').css('display','none')
	}
}
function show_filter_left(data){
	var display = $(data).css('display');
	if(display == "block"){
		$(data).css({'display':'none','margin-left':'-100%'});
	}else{
		$(data).css("display","block");
		$(data).animate({marginLeft:"0"},500)
	}
	var filter = $('.adaptiv-sort-left').find('.close_filtr').css('display');
	if(filter == "inline-block"){
		$('.adaptiv-sort-left').find('.close_filtr').css('display','none')
		$('.adaptiv-sort-left').find('.open_filtr').css('display',' inline-block')
	}else{
		$('.adaptiv-sort-left').find('.close_filtr').css('display',' inline-block')
		$('.adaptiv-sort-left').find('.open_filtr').css('display','none')
	}
}
////////////////////////////////////// and adaptiv filter catalog
$(document).on('mouseup',function (e){
		var div = $('#list-manufacturer'); 
		var el_div = $('#column-left');
		var el_div_2 = $('.adaptiv-sort-left');
		if (!div.is(e.target) && div.has(e.target).length === 0) { 
			$('#list-manufacturer ul').css({'display':'none','width':'0px'});
			$('#list-manufacturer').find('.close_filtr').css('display',' inline-block')
			$('#list-manufacturer').find('.open_filtr').css('display','none')
		}
		if (!el_div.is(e.target) && el_div.has(e.target).length === 0 && !el_div_2.is(e.target)){
			$('#column-left').css({'display':'none','margin-left':'-100%'});
			$('.adaptiv-sort-left').find('.close_filtr').css('display',' inline-block')
			$('.adaptiv-sort-left').find('.open_filtr').css('display','none')
		}
});

$(document).ready(function() {

    //Новоый адаптивный фильтр
    $('#filter-btn').on('click', function () {

        let filter = $('.filter');

        if(filter.hasClass('active')){
            // filter.addClass('d-none');
            filter.removeClass('active');
            $(this).removeClass('hidden');
        }else{
            // filter.css({
            //     'left': '-100px'
            // });
            // filter.removeClass('d-none');
            filter.addClass('active');
            $(this).addClass('hidden');
        }
    });
    $('.filter-btn-close').on('click', function () {
        $('.filter').removeClass('active');
        $('#filter-btn').removeClass('hidden');

    });


    $('.button-search-menu').on('click', function () {
        $('.adaptiv_header_search_line').toggle()
    })
    $('#footer > .column > .adaptiv_info').on('click', function () {
        $(this).siblings('ul').slideToggle(500);
        if ($(this).children('span').html() == '&gt;') {
            $(this).children('span').html('v');
        } else {
            $(this).children('span').html('&gt;');
        }
    });



    //mobile pagination
    $('.pagination-mobile .pages-wrap').animate({width: 'toggle'});

    $(document).on('click','.current-page', function () {

        $('.pagination-mobile .pages-wrap').animate({width: 'toggle'});

    });

	$('.adaptiv-sort-rigth').on('click',function(){
		show_filter_rigth($(this).siblings('ul'));
	});
	
	$('.adaptiv-sort-left').on('click',function(){
		var position = $(this).offset().top + 47;
		$('#column-left').css("top", position+"px");
		var div = $('#column-left');
		show_filter_left(div);
	});
	



	
	
	var path = window.location.pathname;
	if (path.indexOf("galereya") !== -1){
		$(".category-list").css("display","block");
	}
	if (path.indexOf("katalog") !== -1){
		var width_win= document.body.clientWidth;
			if(width_win <= '768'){
				var product_list = $('.product-list');
			if( product_list.length > 0){
					product_list.addClass('product-grid');
					product_list.removeClass('product-list');
			}
		}
	}

    $('#show-more-tags').on('click', function () {

        if($('#show-more-tags').hasClass('active')){

            $(".category-tags").animate({height:40},100);
        }else{
            var el = $(".category-tags"),
                curHeight = el.height(),
                autoHeight = el.css('height', 'auto').height();
            el.height(curHeight).animate({height: autoHeight}, 100);
        }
        $(this).toggleClass('active');
        return false;
    });

	$(function () {
		$('[data-toggle="tooltip"]').tooltip()
	})


/// аякс пагинация
    function getURLParameter(url, name) {
        return (RegExp(name + '=' + '(.+?)(&|$)').exec(url)||[,null])[1];
    }

    let ias = jQuery.ias({
        loadOnScroll: false,
        container: '.js_products',
        item: '.product',
        next: '.next',
        pagination: '.pagination_for_ias',
        // start loading the next page when the user scrolls to (or passed) 400px before the end of the last item
        negativeMargin: 100,
    });

    ias.extension(new IASTriggerExtension({
        offset: parseInt(2, 10) || Infinity,
        text: 'Еще',
        textPrev: 'Предыдущая страница',
        htmlPrev: '<div class="ias-trigger ias-trigger-prev w-100 text-center"><a class="btn btn-outline-danger">{text}</a></div>',
        html: '<div class="ias-trigger ias-trigger-next w-100 text-center"><a class="btn btn-outline-danger">{text}</a></div>'
    }));

    ias.extension(new IASSpinnerExtension({
        html: '<div class="ias-spinner "><i class="fa fa-spinner fa-spin"></i></div>'
    }));

    ias.extension(new IASNoneLeftExtension({
        // text: 'Вы дошли до конца списка.'
        text: ''
    }));

    ias.extension(new IASPagingExtension());

    ias.extension(new IASHistoryExtension({
        prev: '.pagination .prev'
    }));

    let pagesData = [];

    let pageNum = getURLParameter(window.location.href,'page') || 1;
    let h1 = $(document).find('h1').text();
    let paginationMobile = $(document).find('.pagination-mobile').html()
    let pagination = $(document).find('div.pagination').html();

    pagesData[pageNum] = {
        'h1': h1,
        'paginationMobile': paginationMobile,
        'pagination': pagination
    };


    ias.on('pageChange', function (event, scrollOffset, url) {

        console.log(url);

        let pageNum = getURLParameter(url, 'page');
        if (!pageNum) {
            pageNum = 1;
        }
        let data = pagesData[pageNum];
        if (data) {
            $('h1').text(data.h1);
            $('.pagination-mobile').html(data.paginationMobile);
            $('.pagination-mobile .pages-wrap').hide();
            $('div.pagination').html(data.pagination);

        }

    });




    ias.on('loaded', function (data) {
        console.log('loaded');
        // console.log($(data).find('html title').text());
        // document.title = '';
        let pageNum = getURLParameter(window.location.href,'page');
        let h1 = $(data).find('h1').text();
        let paginationMobile = $(data).find('.pagination-mobile').html()
        let pagination = $(data).find('div.pagination').html();
        pagesData[pageNum] = {
            'h1': h1,
            'paginationMobile': paginationMobile,
            'pagination': pagination
        };

        $('h1').text(h1);
        $('.pagination-mobile').html(paginationMobile);
        $('.pagination-mobile .pages-wrap').hide();
        $('div.pagination').html(pagination);
    });


    ias.on('rendered', function(data) {

        //ленивая загрузка для подгруженных товаров
        let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

        if ("IntersectionObserver" in window) {
            let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.srcset = lazyImage.dataset.srcset;
                        lazyImage.classList.remove("lazy");
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            });
            lazyImages.forEach(function(lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });

        }

    });


});
/////// filter




////////////////////////////////

















